export function calculateAgeByEventStartDate(
  eventStartDate: string | Date,
  dateOfBirth: string | Date
): number {
  if (!dateOfBirth) return 0

  const eventStartDateDate = new Date(eventStartDate)
  const dob = new Date(dateOfBirth)

  let age = eventStartDateDate.getFullYear() - dob.getFullYear()

  const monthDiff = eventStartDateDate.getMonth() - dob.getMonth()
  const dayDiff = eventStartDateDate.getDate() - dob.getDate()

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--
  }

  return age
}

export function isMinorByEventStartDate(
  eventStartDate: string | Date,
  dateOfBirth: string | Date
): boolean {
  return calculateAgeByEventStartDate(eventStartDate, dateOfBirth) < 18
}
